import * as Updates from 'expo-updates';

// DO NOT PUT SECRETS IN THIS FILE!!!
// DO NOT PUT SECRETS IN THIS FILE!!!
// DO NOT PUT SECRETS IN THIS FILE!!!
// DO NOT PUT SECRETS IN THIS FILE!!!
// DO NOT PUT SECRETS IN THIS FILE!!!
// DO NOT PUT SECRETS IN THIS FILE!!!
function getEnvironment() {
    // I did it this way so that we could support
    // the web app
    // as well as all work flows via expo
    // I don't love the solution, but it
    // seems like the least bad option
    const environment = process.env.ENVIRONMENT ?? Updates.releaseChannel
    if (environment?.toLowerCase()?.startsWith('prod')) {
        return {
            environment: 'PRODUCTION',
            backendUrl: 'https://votl.io',
            awsRegion: 'us-east-2',
            cognitoUserPoolId: 'us-east-2_t3GGzTwF1',
            cognitoWebClientId: '6hpb38cguc67slb9surpi5dlic'
        };
    } else {
        return {
            environment: 'DEV',
            backendUrl: 'https://dev.votl.io',
            awsRegion: 'us-east-2',
            cognitoUserPoolId: 'us-east-2_75OGp6xJa',
            cognitoWebClientId: '1vti76iat0riana21gd5mlafuh'
        };
    }
}

const environment = getEnvironment()
export default environment